import { TranslationsMap } from '../i18n/translate';
import { AppDefId } from '../../constants/constants';
import { ISettings } from '../../types';
import { getInitialSettings } from '../configuration/get-initial-settings';

export interface ComponentSettings {
  settings: ISettings;
  translations: TranslationsMap;
}

class ComponentSettingsService {
  settings?: ComponentSettings;

  async getSettings(): Promise<ISettings> {
    await this.loadSettings();
    return this.settings?.settings || getInitialSettings();
  }

  async getTranslations(): Promise<TranslationsMap> {
    await this.loadSettings();
    return {
      ...this.settings?.settings?.texts,
      ...this.settings?.translations,
    };
  }

  async loadSettings() {
    const locale = window.wixEmbedsAPI?.getLanguage() || 'en';
    this.settings = await fetch(
      `/_api/app-settings-service/v1/settings/components/${AppDefId}?languageKey.languageCode=${locale}&host=BUSINESS_MANAGER&state=NR`,
      {
        method: 'GET',
        cache: 'no-cache',
        headers: {
          Authorization: getAuthorization(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
    )
      .then((res) => res.json())
      .catch((reason) => {
        console.log(`error receiving component settings ${reason}`);
        return getInitialSettings();
      });
  }
}

export const componentSettingsService = new ComponentSettingsService();

const getAuthorization = (): string =>
  window.wixEmbedsAPI?.getAppToken(AppDefId) || '';
